<template lang="pug">
.denuncia-resultado
    .denuncia-resultado__mensagem(
        :class='{ "denuncia-resultado__mensagem--negativo": !state.quantidadeResultados, "denuncia-resultado__mensagem--positivo": !!state.quantidadeResultados }'
    )
        i.mdi(
            :class='{ "mdi-check-circle-outline": !state.quantidadeResultados, "mdi-alert-circle-outline": !!state.quantidadeResultados }'
        )
        span(v-html='formatarMensagemResultado(state.quantidadeResultados)')
    #denuncia-resultado-exportar.denuncia-resultado__table(
        v-if='state.resultados.length > 0'
    )
        el-table.tabela-dados__table(
            :data='listaResultados.data',
            stripe,
            border,
            show-overflow-tooltip,
            style='width: 100%',
            @sort-change='handleSortChangeResults'
        )
            el-table-column(
                v-for='(col, index) in resultadosColLista()',
                :key='`resultado-col-${index}`',
                :resizable='true',
                :prop='col.prop',
                :label='col.label',
                :width='colWidth(col.prop)',
                :sortable='temOrdencao(col.prop)'
            )
                el-tag(
                    v-if='col.prop === "statusContrato"',
                    slot-scope='scope',
                    :round='false',
                    :type='obterStatus(scope.row[col.prop]).type'
                ) {{ obterStatus(scope.row[col.prop]).status }}
                span(
                    v-else,
                    slot-scope='scope',
                    v-html='formataValor(scope.row[col.prop], col.prop)'
                )
            template(slot='empty')
                el-empty.tabela-dados__empyt(
                    :description='translate("table_vazio")'
                )
        .paginacao(v-if='!state.exportando')
            span.total-paginas {{ formatarTotalPaginas(listaResultados.totalItens) }}
            el-pagination(
                size='small',
                layout='prev, pager, next',
                :total='listaResultados.totalItens',
                :page-size='state.itensPorPagina === 1 ? listaResultados.data.length : state.itensPorPagina',
                :page-count='listaResultados.totalPaginas',
                @current-change='mudarPaginaResuldados'
            )
</template>
<script>
import { defineComponent } from 'vue';
import useShareReport from '@/modules/denuncia/composition/useShareReport';
import useShareReportInsert from '@/modules/denuncia/composition/useShareReportInsert';
import { obterStatus, formatarMensagemResultado } from '../../mixins';

export default defineComponent({
    setup() {
        const {
            state,
            listaResultados,
            handleSortChangeResults,
            mudarPaginaResuldados
        } = useShareReport();
        const { translate } = useShareReportInsert();

        const resultadosCols = {
            numeroContrato: translate('table_col_num_contrato'),
            nomeParceiro: translate('table_col_nome_parceiro'),
            cpfCnpj: translate('table_col_cpf_cnpj_produtor'),
            car: translate('table_col_car'),
            anoSafra: translate('table_col_ano_safra'),
            commodity: translate('table_col_commodity'),
            volumeAtribuido: translate('table_col_vol_atribuido'),
            statusContrato: translate('table_col_status'),
            dataConclusao: translate('table_col_data_conclusao'),
            local: translate('table_col_local')
        };

        const resultadosColLista = () =>
            Object.keys(resultadosCols).map(key => ({
                prop: key,
                label: resultadosCols[key]
            }));

        const formatarTotalPaginas = totalItens =>
            totalItens > 1
                ? `${totalItens} ${translate('dados')}`
                : `${totalItens} ${translate('dado')}`;

        const temOrdencao = col =>
            [
                'nomeParceiro',
                'car',
                'anoSafra',
                'volumeAtribuido',
                'statusContrato',
                'dataConclusao',
                'local'
            ].includes(col)
                ? 'custom'
                : false;

        const colWidth = col => {
            switch (col) {
                default:
                    return 'auto';
            }
        };

        const formataValor = (valor, col) => {
            switch (col) {
                case 'volumeAtribuido':
                    return valor ? `${valor} t` : '-';
                default:
                    return valor || '-';
            }
        };

        return {
            state,
            listaResultados,
            obterStatus,
            temOrdencao,
            colWidth,
            formatarTotalPaginas,
            handleSortChangeResults,
            mudarPaginaResuldados,
            translate,
            resultadosColLista,
            formatarMensagemResultado,
            formataValor
        };
    }
});
</script>

<style lang="scss">
.denuncia-resultado {
    display: flex;
    flex-direction: column;
    gap: 20px;
    &__mensagem {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 16px;
        height: 42px;
        width: 100%;
        margin-top: 8px;
        & i {
            font-size: 28px;
            width: 42px;
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-top-left-radius: $default-border-radius;
            border-bottom-left-radius: $default-border-radius;
        }
        &--negativo {
            background-color: #e0ebc8;
            border-radius: $default-border-radius;
            & i {
                color: #3d963c;
                background-color: #c1e083;
            }
        }
        &--positivo {
            background-color: #f8d7da;
            border-radius: $default-border-radius;
            & i {
                color: #a94442;
                background-color: #f0b3b2;
            }
        }
    }
    &__table {
        border-top-left-radius: $default-border-radius;
        border-top-right-radius: $default-border-radius;
        width: 100%;
        min-height: 300px;
        margin-top: 20px;
    }
    &__empyt svg {
        width: 98px !important;
    }
    .paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        background-color: $white;
        border-bottom-left-radius: $default-border-radius;
        border-bottom-right-radius: $default-border-radius;
        padding: 15px;

        .number.active {
            background-color: $primary !important;
            border-radius: $default-border-radius;
            color: $white;
        }

        .total-paginas {
            color: $primary;
            font-weight: bold;
        }
    }
    .el-tag {
        border-radius: $default-border-radius !important;
        font-weight: bold;
    }
}
</style>
